import React, { Component } from 'react'
import Link from '../../utils/link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Play } from '../icons'
import FsLightbox from 'fslightbox-react'

class VideoCard extends Component {

  state = {
    videoLightbox: false,
  }

  render() {

    const { title, featuredImage, categories, acf } = this.props
    let { videoLightbox } = this.state
    let video = acf.video !== '' ? `https://www.youtube.com/watch?v=${acf.video.split('.be/')[1]}&autoplay=1` : ''

    return (
      <div className='video-card'>
        <div className='video-card__image' onClick={() => this.setState({ videoLightbox: !videoLightbox })}>          
          <img loading='lazy' src={featuredImage?.node?.sourceUrl} alt={title} />
          { acf.categories?.length > 0 && <span className='video-card__tag'>{acf.categories[0]}</span> }
          <span className='play'><Play color={'#FFFFFF'} /></span>
        </div>
        <div className='video-card__title' onClick={() => this.setState({ videoLightbox: !videoLightbox })}>
          <h4 dangerouslySetInnerHTML={{ __html: title }} />
        </div>
        { acf.video &&
          <FsLightbox
            toggler={videoLightbox}
            sources={ [
              video
            ]}
          />
        }
      </div>
    )
  }
}

export default VideoCard
